import React from "react";
import { gql } from "apollo-boost";

import SettingsList from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createLegalByAdmin($title: String!, $description: String!) {
    createLegalByAdmin(input: { title: $title, description: $description }) {
      _id
      title
    }
  }
`;

const GET = gql`
  query getLegals($limit: Int, $skip: Int) {
    getLegals(pagination: { limit: $limit, skip: $skip }) {
      _id
      title
      description
      order
    }
  }
`;

const COUNT = gql`
  query getLegalsCount {
    getLegalsCount
  }
`;

const UPDATE = gql`
  mutation updateLegalByAdmin($id: ID!, $title: String!, $description: String!, $order: Int) {
    updateLegalByAdmin(id: $id, input: { title: $title, description: $description, order: $order }) {
      _id
      title
    }
  }
`;

const DELETE = gql`
  mutation removeLegalByAdmin($idSet: [ID!]!) {
    removeLegalByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const FIELDS = [
  { name: "title", label: "Title", type: "text", required: true },
  {
    name: "description",
    label: "Text",
    type: "textarea",
    required: true,
    hint: "The whole policy. Customers read this in the app exactly as written here.",
  },
  {
    name: "order",
    label: "Position",
    type: "number",
    defaultValue: 0,
    hint: "Lower numbers appear first.",
  },
];

/**
 * Legals - the policy pages the apps link to.
 *
 * Creating a policy had no `order` field even though the record has
 * one, so every new policy landed with whatever the server defaulted
 * to and could only be ordered by editing it afterwards.
 */
const Legals = () => (
  <SettingsList
    title="Policies"
    description="Terms, privacy and the rest, as customers and drivers read them."
    singular="policy"
    list={{ query: GET, key: "getLegals" }}
    count={{ query: COUNT, key: "getLegalsCount" }}
    create={{
      mutation: ADD,
      variables: (values) => ({
        title: values.title.trim(),
        description: values.description.trim(),
      }),
    }}
    update={{
      mutation: UPDATE,
      variables: (values, row) => ({
        id: row._id,
        title: values.title.trim(),
        description: values.description.trim(),
        order: values.order === "" ? null : parseInt(values.order, 10),
      }),
    }}
    remove={{ mutation: DELETE }}
    columns={[
      { key: "title", label: "Title", width: "1.5fr" },
      {
        key: "description",
        label: "Text",
        width: "3fr",
        render: (row) => <span className="settingsClamp">{row.description}</span>,
      },
      { key: "order", label: "Position", width: "90px" },
    ]}
    fields={FIELDS}
    toValues={(row) => ({
      title: row.title,
      description: row.description,
      order: row.order === null || row.order === undefined ? "" : row.order,
    })}
  />
);

export default Legals;
